import React from 'react'

const Footer = () => {
  return (
    <div className="footer_wrap">
      <div className="spge">
        <p>
          <span className="bold">“지역소상공인”</span>과 함께하는
        </p>
        <p>
          <span className="bold">&#40;주&#41;에스피지이</span> www.spge.kr
        </p>
      </div>
      <div className="address">
        <p>서울시 강서구 마곡중앙로 161-8, C동 507호</p>
        <p>&#40;마곡동, 두산더랜드파크&#41;</p>
      </div>
      <div className="business_num">사업자번호 383-87-01230</div>
      <div className="cs_num">고객센터 050-7964-1000</div>
      <div className="logo_spge"></div>
    </div>
  )
}

export { Footer }
